import {
  PageConfig,
  Question,
} from "../../../components/content-blocks/forms/customer-form-types";

export function collapseQuestions({
  pages,
  name,
  title,
}: {
  pages: PageConfig[];
  name: string;
  title: string;
}): PageConfig {
  const page: PageConfig = {
    name,
    title,
    questions: [],
    elements: [],
  };

  let lastQuestion: Question;
  pages.forEach(({ visibleIf, questions, elements }) => {
    if (questions) {
      questions.forEach((question) => {
        let { startWithNewLine } = question;
        if (
          lastQuestion &&
          (lastQuestion.type === "text" ||
            lastQuestion.type === "radiogroup" ||
            lastQuestion.type === "comment") &&
          lastQuestion.startWithNewLine !== false &&
          (question.type === "text" ||
            question.type === "radiogroup" ||
            question.type === "comment") &&
          startWithNewLine !== false
        ) {
          startWithNewLine = false;
        }
        lastQuestion = {
          ...question,
          startWithNewLine,
        };

        page.questions.push({
          ...question,
          visibleIf: question.visibleIf || visibleIf,
          startWithNewLine,
        });
      });
    }

    if (elements) {
      page.elements = [...page.elements, ...elements];
    }
  });

  return page;
}
